import en from "./en";
import fr from "./fr";
import { translationLocale } from "./locale";
import getTranslationFunction from "../lib/i18n";

export const locales = ["fr", "en"] as const;

const translations = translationLocale === "fr" ? fr : en;

const t = getTranslationFunction(translations);

export default t;
